import axios from "axios";
import filters from "../../models/workflow/filters";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getAllFilters() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/workflow/operfiltros`, { headers })
      .then(({ data }) => {
        return data.map((item) => {
          return filters.fromJson(item);
        });
      });
  }
  getFilter(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const operid = data.operid;

    return axios
      .get(`${url}/workflow/operfiltros${operid}`, { headers })
      .then(({ data }) => {
        return data.map((item) => {
          return filters.fromJson(item);
        });
      });
  }

  new(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload = {
      operId: data.operId,
      fecDesde: data.from,
      mios: data.mios,
      pendientes: data.pending,
      aprobadas: data.approved,
      rechazadas: data.rejected,
      licencias: data.licenses,
      cHorario: data.cSchedule,
      hsExtra: data.hsExtra,
      licF: data.licF,
      dele: data.dele,
    };

    if (data.fecHasta) {
      payload = {
        ...payload,
        fecHasta: data.fecHasta,
      };
    }

    return axios.post(`${url}/workflow/operfiltros`, payload, { headers });
  }
  delete = (data) => {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const operid = data;

    return axios.delete(`${url}/workflow/operfiltros/${operid}`, {
      headers,
    });
  };

  edit(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const operid = data.operId;

    let payload = {
      fecDesde: data.from + "T00:00:00.000Z",
      mios: data.mios,
      pendientes: data.pending,
      aprobadas: data.approved,
      rechazadas: data.rejected,
      licencias: data.licenses,
      cHorario: data.cSchedule,
      hsExtra: data.hsExtra,
      licF: data.licF,
      dele: data.dele,
      columnas: data.columnas,
    };
    if (data.to) {
      payload = {
        ...payload,
        fecHasta: data.to + "T00:00:00.000Z",
      };
    } else {
      payload.nuncaExpira = true;
    }

    return axios
      .put(`${url}/workflow/operfiltros/${operid}`, payload, { headers })
      .then(() => {});
  }
}
export default service;
